import React, { useContext, useState } from "react";
import Image from "components/image";
import Link from "helpers/link";
import { TELEPHONE_NUMBER } from "utils/constants";
import { CartContext } from "context/cart";
import Icon from "@root/_components/Icon/icon";
import MobileHeaderData from "./data";
import SearchByImage from "@root/components/header/search-by-image";
import MobileSearch from "./mobile-search";
import lockBodyScroll from "@helpers/lockBodyScroll";
import { SearchContext } from "context/search";

const MobileHeader = ({ data: { logo, links } }) => {
    const { cart: { items } } = useContext(CartContext);
    const [openedSidebar, setSidebar] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const { isMobileSearchOpen, openSearch, closeSearch } = useContext(SearchContext);

    lockBodyScroll(showSearch, true);

    return (
        <header className="header header--mobile">
            <nav className="header__container" aria-label="Main Menu">
                <div className="container">
                    <div className="header__controls">
                        <button
                            type="button"
                            onClick={() => setSidebar((prevState) => !prevState)}
                            aria-label="hamburger-menu"
                            className="header__hamburger-btn"
                        >
                            <Icon icon="menu" color="#00334e" size={32} />
                        </button>
                        <Image image={logo} to="/" width={125} className="header__logo" />
                    </div>
                    <div className="header__actions">
                        <button
                            type="button"
                            onClick={() => openSearch()}
                            aria-label="search"
                            className="header__actions--search"
                        >
                            <Icon icon="search" color="#00334e" size={24} />
                        </button>
                        <Link to={TELEPHONE_NUMBER} aria-label="Call Us" className="header__actions--phone">
                            <Icon icon="phone-call" color="#00334e" size={24} />
                        </Link>
                        {/*<Link to="/account" aria-label="Navigate to account page" className="header__actions--account">*/}
                        {/*    <Icon icon="user" color="#00334e" size={24} />*/}
                        {/*</Link>*/}
                        <Link to="/cart" aria-label="Navigate to cart page" className="header__actions--cart">
                            <Icon icon="shopping-bag" color="#00334e" size={24} />
                            {items?.length ? <div className="header__cart-badge" /> : <div className="header__cart-badge--hidden" />}
                        </Link>
                    </div>
                </div>
            </nav>
            <MobileHeaderData
                data={links}
                logo={logo}
                openedSidebar={openedSidebar}
                setSidebar={setSidebar}
            />
            {isMobileSearchOpen && <MobileSearch onClose={() => closeSearch()} />}
        </header>
    );
};

export default MobileHeader;
